import type { ReactNode } from 'react';

import { cn } from '@/lib/utils/cn';

interface PageHeaderProps {
  title: string;
  description?: string;
  action?: ReactNode;
  className?: string;
}

/**
 * Shared page header. Uses the 0xCent gold accent for titles to keep the
 * fintech/crypto vibe consistent across screens.
 */
export function PageHeader({
  title,
  description,
  action,
  className,
}: PageHeaderProps): JSX.Element {
  return (
    <header
      className={cn(
        'flex items-start justify-between gap-4 border-b border-border/40 pb-4',
        className,
      )}
    >
      <div className="min-w-0 flex-1">
        <h1 className="truncate bg-gradient-to-r from-accent-gold to-accent-purple bg-clip-text text-2xl font-bold text-transparent">
          {title}
        </h1>
        {description && (
          <p className="mt-1 text-sm text-text-secondary">{description}</p>
        )}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </header>
  );
}
